import { MediaMatcher } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
declare let $: any;
@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  isShowing: boolean = true;
  /**
   * Constructs the NavbarComponent and sets up the media query listener
   * to handle responsive design based on screen size.
   *
   * @param router Angular Router for navigation.
   * @param changeDetectorRef Reference to Angular's change detector for
   *                          triggering change detection.
   * @param media Service to match media queries for responsive design.
   */
  constructor(
    private router: Router,
    changeDetectorRef: ChangeDetectorRef,
    media: MediaMatcher
  ) {
    // Initialize the mobile query to detect when the screen size is below 992px.
    this.mobileQuery = media.matchMedia('(max-width: 991px)');

    // Define the listener to trigger change detection when the media query changes.
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();

    // Add the listener to the mobile query.
    this.mobileQuery.addListener(this._mobileQueryListener);

    // Toggle the isShowing flag based on the initial state of the media query match.
    if (this.mobileQuery.matches) {
      this.isShowing = !this.isShowing;
    }
  }
  /**
   * Lifecycle hook that is called after the component is initialized.
   * It sets up a scroll event listener that adds or removes the
   * "toptotop" class and the box-shadow style from the navbar based on the
   * scroll position.
   * It also sets up a click event listener on the navbar-collapse's ul
   * items, which removes the "show" class from the navbar-collapse when an
   * item is clicked.
   */
  ngOnInit(): void {
    $(document).ready(function () {
      $(window).on('scroll', function () {
        // If the scroll position is greater than 90, add the "toptotop" class
        // and the box-shadow style to the navbar. Otherwise, remove them.
        if ($(this).scrollTop() > 90) {
          $('.navbar.navbar-expand-lg').addClass('toptotop');
          $('.navbar.navbar-expand-lg').css('box-shadow', '0px 0px 5px');
        } else {
          $('.navbar.navbar-expand-lg').css('box-shadow', 'none');
          $('.navbar.navbar-expand-lg').removeClass('toptotop');
        }
      });
    });
    // When an item in the navbar-collapse is clicked, remove the "show"
    // class from the navbar-collapse element.
    $('nav .navbar-collapse ul li').click(function () {
      $('.navbar-collapse').removeClass('show');
    });
  }
  /**
   * This method is called when the "Registration" button is clicked.
   * It will remove the show class from the navbar-collapse element, which will hide the dropdown menu.
   * It will also navigate to the registration page.
   */
  registerBtn() {
    // Remove the show class from the navbar-collapse element
    $('.navbar-collapse').removeClass('show');

    // Navigate to the registration page
    this.router.navigate(['register', {}]);
  }

  mobileQuery: MediaQueryList;
  fillerNav = Array.from({ length: 50 }, (_, i) => `Nav Item ${i + 1}`);
  private _mobileQueryListener: () => void;
  /**
   * Lifecycle hook that is called after the component is destroyed.
   * It removes the event listener for the mobile query.
   */
  ngOnDestroy(): void {
    // Remove the event listener to prevent memory leaks
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
